<template>
	<v-card>
		<v-card-title class="mb-4">
			<v-sheet
				color="primary"
				class="text-white pa-4"
				rounded
			>
				<v-row
					no-gutters
				>
					<v-col class="d-flex align-center justify-space-between">
						<translate>Order placed</translate>
						<v-icon icon="$check" />
					</v-col>
				</v-row>
			</v-sheet>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col class="d-flex justify-center">
					<v-img
						src="/frontoffice/images/brand/icons/icon-228.png"
						max-width="300"
						max-height="300"
					/>
				</v-col>
			</v-row>
			<v-row
				align="center"
				justify="center"
			>
				<v-col>
					<v-btn
						min-width="300"
						variant="flat"
						color="primary"
						@click="window.location.reload()"
					>
						<translate>New Order</translate>
					</v-btn>
				</v-col>
			</v-row>
			<v-row
				align="center"
				justify="center"
				class="ma-4"
			>
				<v-col>
					<v-btn
						min-width="300"
						variant="tonal"
						@click="window.location.href='/resellers'"
					>
						<translate>Home</translate>
					</v-btn>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: 'OrderCompletion',

};
</script>
